// extracted by mini-css-extract-plugin
export var actionButton = "_99-0";
export var attachmentLine = "_99-1";
export var fileInput = "_99-2";
export var fileUploadWrapper = "_99-4";
export var footer = "_99-3";
export var modalContent = "_99-5";
export var paperclip = "_99-6";
export var quillEditor = "_99-7";